import React from 'react';
import { Navigate } from 'react-router-dom';

const VerifyOTPNavigationComponent = ({step}) => {
    const url = `/referral/status/verify-otp`;

    if (step === 2) {
        return (
            <Navigate
                to={url}
            />
        );
    }
    return null;
}
export default VerifyOTPNavigationComponent;